import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from 'src/app/shared/services/auth.service';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { fibraSpeeds, orderType, brandPortability, stepsShowRatesByBrand} from 'src/app/shared/constantes';
import { SimyoService } from './simyo.service';
import { map, tap } from 'rxjs/operators';
import { PermissionService } from 'src/app/shared/services/permission.service';
import { SimyoOrderService } from './simyo-order.service';
import { SimyoStepperService } from './simyo-stepper.service';

export interface IshowOffer {
    index: any,
    status: boolean
}

@Injectable({
    providedIn: 'root'
})
export class SimyoRateService {

    private rates: any;
    private errorRate: any;
    private errorRateAdditional: any;
    private showRateOnOffer: any;
    private simyoOrderService: SimyoOrderService;
    private simyoService: SimyoService;
    private askPortability = false;

    constructor(
        protected http: HttpClient,
        private auth: AuthService,
        private permissionService: PermissionService,
        private injector: Injector,
        //private simyoService: SimyoService,
        private stepperService: SimyoStepperService

    ) {
        this.rates = new BehaviorSubject<any>(null);
        this.errorRate = new BehaviorSubject(false);
        this.errorRateAdditional = new BehaviorSubject(false);
        this.showRateOnOffer = new BehaviorSubject<IshowOffer>({index: 0, status: true});
    }

    private getHeaders(): HttpHeaders {
        return new HttpHeaders({
            Authorization: 'Bearer ' + this.auth.getToken(),
            'Content-Type': 'application/json'
        });
    }

    getRatesFromService(zip_code?, flow?, mas_mobile?, has_max_broadband?, max_broadband?, is_client_active?, mobile_can_package?, is_special_300?, is_portability_other_brand?, provider_id?) {
        let body = {
            permissions: this.permissionService.getPermissionSimyoRates(),
            is_client_active: is_client_active,
            mobile_can_package: mobile_can_package,
            cp: zip_code ?  zip_code : '',
            flow: flow,
            has_max_mobile: mas_mobile,
            has_max_broadband: has_max_broadband,
            speed_max_broadband: max_broadband,
            is_special_300: is_special_300,
            is_portability_other_brand: is_portability_other_brand,
            provider_id: provider_id

        };
        return this.http.post(
            environment.simyoEndPoint + 'master/rates/matrix',
            body,
            {headers: this.getHeaders()}
        );
    }

    getRechargePrice(price): any {
        return Math.ceil(price/5)*5;
    }

    setRates(data) {
        this.rates.next(data);
    }

    getRates() {
        return this.rates.asObservable();
    }

    getCurrentRatesValue() {
        return this.rates.getValue();
    }

    setErrorRate(data) {
        this.errorRate.next(data);
    }

    getErrorRate() {
        return this.errorRate.asObservable();
    }

    setErrorRateAdditional(data) {
        this.errorRateAdditional.next(data);
    }

    getErrorRateAdditional() {
        return this.errorRateAdditional.asObservable();
    }

    setShowRateOnOffer(data: IshowOffer) {
        this.showRateOnOffer.next(data);
    }

    getShowRateOnOffer() {
        return this.showRateOnOffer.asObservable();
    }

    isAdditional(index, customerInfo, typeOrder, order?, speed = '300'): boolean {
        if(typeOrder === orderType.BROADBAND) {
            return false;
        }
        if (!customerInfo && !speed) {
            return false;
        }
        if(customerInfo?.max_broadband == null && order?.broadband?.rate_id == null) {
            return false;
        }

        if (order && order.mobiles) {
            let indexMainLine = order.mobiles.findIndex(mobile => mobile.rate?.is_main_line && mobile.rate?.rate_info.available_in.includes(`ftth_${speed}`));
            if(indexMainLine < 0 && customerInfo && customerInfo.max_mobile) {
                return customerInfo.max_mobile.rate_info.available_in.includes(`ftth_${speed}`)
            }
            return indexMainLine >= 0 && indexMainLine !== index;
        }

        if (customerInfo && customerInfo.max_mobile) {
            return customerInfo.max_mobile.rate_info?.available_in?.includes(`ftth_${speed}`)
        }

        return false;
    }

    anyRateMobileForOffer(order): boolean {
        let result = false;
        if (order && order.mobiles && order.mobiles.length) {
            order.mobiles.map(mobile => {
                if (this.getPriceMobile(mobile) >= 7) {
                    result = true;
                }
            })
        }
        return result;
    }

    getPriceMobile(rateMobile: any): number {
        if (rateMobile && rateMobile.rate) {
            let priceBonos = 0;
            // if (rateMobile.rate.bonos && rateMobile.rate.bonos.length) {
            //     rateMobile.rate.bonos.forEach(x => {
            //         priceBonos += +x.rate_info.price;
            //     });
            // }
            return +rateMobile.rate.rate_info.price + priceBonos;
        }
        return 0;
    }

    public determineRates(matrix?: any, index = 0) {
        let isPortabilityOtherBrand = this.getSimyoOrderService().getIsPortabilityOtherBrand();

        if (!isPortabilityOtherBrand) {
            return matrix?.RATES;
        }

        if ((isPortabilityOtherBrand == 'Otros' || isPortabilityOtherBrand == 'antidigi')  && this.getSimyoOrderService().getCpOtherBrand() == '12') {
            
           /* let currentIndex = index != 0 ? index : this.stepperService.getCurrentStep();

            if(stepsShowRatesByBrand[brandPortability.digi]().includes(currentIndex) == false) {
                return matrix?.RATES;
            }

            let rateInfo = this.getSimyoService().customerInfo != null ? this.getSimyoService().customerInfo.max_mobile?.rate_info : this.getSimyoService().customerData?.max_mobile?.rate_info;
            let hasValidRate = rateInfo?.data && matrix?.PARAMS.RATE_DIGI_PRODUCT_CODE.includes(rateInfo?.product_code) /*&& rateInfo?.voice === 'ILIMITADOS'*/;

            /*if (hasValidRate) {
                return {
                    ADDITIONALS : matrix?.RATES?.ADDITIONALS,
                    FTTH_NEW : matrix?.RATES_BY_BRAND?.digi.FTTH_NEW,
                    MOBILE : matrix?.RATES?.MOBILE
                }
            }*/
            return matrix?.RATES_BY_BRAND?.digi;
        }

        return matrix?.RATES;
    }


    private getSimyoOrderService(): SimyoOrderService {
        if (!this.simyoOrderService) {
            this.simyoOrderService = this.injector.get(SimyoOrderService);
        }
        return this.simyoOrderService;
    }

    private getSimyoService(): SimyoService {
        if (!this.simyoService) {
            this.simyoService = this.injector.get(SimyoService);
        }
        return this.simyoService;
    }

    public getAskPortability() {
        return this.askPortability;
    }

    public setAskPortability(askPortability) {
        this.askPortability = askPortability;
    }

    public checkIsAdditional(rate) {
        if(rate == null || rate?.is_additional == false) {
            return false;
        }

        if(this.getSimyoOrderService().getIsPortabilityOtherBrand() != null && rate.rate_info?.product_code == "410225"){
            return true;
        }

        return  +rate.rate_info?.old_price > +rate.rate_info?.price

    }
}
